import { render, staticRenderFns } from "./BorradoresIberdrola.vue?vue&type=template&id=52ce9361"
import script from "./BorradoresIberdrola.vue?vue&type=script&lang=js"
export * from "./BorradoresIberdrola.vue?vue&type=script&lang=js"
import style0 from "./BorradoresIberdrola.vue?vue&type=style&index=0&id=52ce9361&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports